import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
declare var jquery: any;
declare var $: any;
import { GridOptions } from "ag-grid/main";
import { ToastrService } from 'ngx-toastr';
import { Globals } from "app/globals";
import { isUndefined, isNull } from 'util';
//import { setTimeout } from 'timers';
import { AdminService, SaveAssessmentsDto } from 'app/services/admin/AdminService';
import { AssessmentsService, PageObjDto } from 'app/services/assessment/AssessmentsService';
import { TemplatesService } from 'app/services/template/TemplatesService';
import { NewRegularModalComponent } from '../new-regular-modal/new-regular-modal.component';
import { NewSatisfactionModalComponent } from '../new-satisfaction-modal/new-satisfaction-modal.component';
import { NewSurveyModalComponent } from '../new-survey-modal/new-survey-modal.component';
// import { forEach } from '@angular/router/src/utils/collection';


@Component({
    selector: 'app-new-eli-assessment',
    templateUrl: './new-eli-assessment.component.html',
    styleUrls: ['./new-eli-assessment.component.scss']
})

export class NewEliAssessmentComponent implements OnInit {

    @ViewChild('newregular', {static: true}) public newRegularModal: NewRegularModalComponent;
    @ViewChild('newsatisfaction', {static: true}) public newSatisfactionModal: NewSatisfactionModalComponent;
    @ViewChild('newsurvey', {static: true}) public newSurveyModal: NewSurveyModalComponent;

    
    _onRowDragEnd: any;
    _onRowDragEnter: any;
    version: string;
    niches:any[] = []

    tags: string[] =["Business","ELI","New Client"];
    
    /*--modal questions--*/
    questions = new Array();
    questionType: string;
    currentQuestionType: number;
    questionsHeaders: any[];
    questionsGridOptions: GridOptions;
    questionsGridApi;
    rowSelection;

    /*generic all ag-grid*/
    overlayNoRowsTemplate;
    height: number;
    count: number;

    /*regular*/
    regular_questions: any[] = [];
    deleted_regular_questions: any[] = [];
    regularHeaders: any[];
    regularGridOptions: GridOptions;
    regularGridApi;

    /*satisfaction*/
    satisfaction_questions: any[] = [];
    deleted_satisfaction_questions: any[] = [];
    satisfactionHeaders: any[];
    satisfactionGridOptions: GridOptions;
    satisfactionGridApi;

    /*survey*/
    survey_questions: any[] = [];
    deleted_survey_questions: any[] = [];
    surveyHeaders: any[];
    surveyGridOptions: GridOptions;
    surveyGridApi;

    /*regularSection*/
    section1_questions: any[] = [];
    deleted_section1_questions: any[] = [];
    section1Headers: any[];
    section1GridOptions: GridOptions;
    section1GridApi;

    /*satisfactionSection*/
    section2_questions: any[] = [];
    deleted_section2_questions: any[] = [];
    section2Headers: any[];
    section2GridOptions: GridOptions;
    section2GridApi;

    /*edit*/
    assessmentId: number;
    majorVersion: number;
    minorVersion: number;
    name: string;
    nicheName: string;
    nicheId:number = 0;

    regularSection: any;
    satisfactionSection: any;
    surveySection: any;
    section1: any;
    section2: any;

    showAssessmentPreview: boolean;

    //flag to handle the deleted questions
    excludeDeleted: boolean = false;

    regularChoiceSets: any[];
    satisfactionChoiceSets: any[];
    rChoiceSet: number = 0;
    sChoiceSet: number = 0;

    section1ChoiceSets: any[];
    section2ChoiceSets: any[];

    section1currentChoiceSet: number = 0;
    section2currentChoiceSet: number = 0;

    templateId: number;

    templates: string[] = [];

    invitations: any[] = [];
    reminders: any[] = [];
    results: any[] = [];

    invitation: number;
    result: number;
    reminder: number;

    coachReports: any[] = [];
    clientReports: any[] = [];
    coachTemplateId: number;
    clientTemplateId: number;

    section1Type: number = 4;
    section2Type: number = 5;
    baseEli: any[] = [];
    regularAssessment: number;

    showAssessment360: boolean = true;
    currentSelectedTab: any = 0;

    //selects data
    clientInvitations: any[] = [];
    clientResults: any[] = [];
    clientResultsAvailable: any[] = [];
    clientReminders: any[] = [];

    raterInvitations: any;
    raterResults: any[] = [];
    raterReminders: any[] = [];

    coachInvitations: any[] = [];
    coachResults: any[] = [];
    coachReminders: any[] = [];

    //selects
    clientInvitation: any = 0;
    clientReminder:any = 0;
    clientResult: any = 0;
    clientResultAvailable:any = 0;

    raterInvitation:any = 0;
    raterReminder:any = 0;

    coachResult: any = 0;

    newAssessment: boolean = false;

    loading: boolean = true;

    emailTemplates = [];

    /*pages tab*/
    languages: string[] = [];
    pageTypes: any[] = [];
    templateFields: any[] = [];

    public editor;
    public editorContent = ``;
    public editorOptions = { placeholder: "insert content..." };

    htmlBody: string = null;
    text: string = "";
    editorInstance: any;
    range: any;

    selectPageType:string = "";
    selectLanguage: string = "";

    pagesArr: PageObjDto[] = [];
    pos = 0;
    iteration: number = 0;
    currentPageSelectedType: number = 3;
    assessmentPrice: number = 0;
    currentRowIndex: number = 0;

    checkTrue = []
    checkfalse = [];

    constructor(
        private _AdminService: AdminService,
        private _TemplatesService: TemplatesService,
        private _AssessmentsService: AssessmentsService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private toastr: ToastrService,
        private _Globals: Globals

    )
    {
        this.activatedRoute.params.subscribe(params => {
            this.assessmentId = parseInt(params['id']);
            if (isNaN(this.assessmentId)) {
                this.newAssessment = true;
            }
        });

        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "multiple";
    }

    ngOnInit() {
        if (this._Globals.previewAssessmentId != undefined) {
            console.log('globals', this._Globals);
        }

        this.getNiches();
        this.GetChoiceSets(1);
        this.GetChoiceSets(2);
        this.GetChoiceSets(this.section1Type);
        this.GetChoiceSets(this.section2Type);

        //this.getEmailTemplatesByPurpose(1);
        //this.getEmailTemplatesByPurpose(2);
        //this.getEmailTemplatesByPurpose(3);

        this.getEmailTemplatesByUserTypeByPurpose(3, 1); // client invitation
        this.getEmailTemplatesByUserTypeByPurpose(3, 3); // client reminder
        this.getEmailTemplatesByUserTypeByPurpose(3, 4); // client resultAvailable
        this.getEmailTemplatesByUserTypeByPurpose(3, 2); // client result

        this.getEmailTemplatesByUserTypeByPurpose(4, 1); // rater invitation
        this.getEmailTemplatesByUserTypeByPurpose(4, 3); // rater reminder
        this.getEmailTemplatesByUserTypeByPurpose(4, 2); // rater result

        this.getEmailTemplatesByUserTypeByPurpose(2, 1); // coach invitation
        this.getEmailTemplatesByUserTypeByPurpose(2, 3); // coach reminder
        this.getEmailTemplatesByUserTypeByPurpose(2, 2); // coach result

        //this.getTemplatesByType();
        this.getTemplatesByUserType(2);
        this.getTemplatesByUserType(3);

        /*PAGES*/
        this.getLanguages();
        this.getPageTypes();
        this.getTemplateFields();

        /*modal*/
        this.questionsGridOptions = <GridOptions>{};
        this.questionsGridOptions.rowHeight = 45;
        this.questionsGridOptions.headerHeight = 40;
        this.questionsHeaders = this.createModalHeaders();

        /*regular*/
        this.regularGridOptions = <GridOptions>{};
        this.regularGridOptions.rowHeight = 45;
        this.regularGridOptions.headerHeight = 40;
        this.regularHeaders = this.createRegularHeaders();

        /*satisfaction*/
        this.satisfactionGridOptions = <GridOptions>{};
        this.satisfactionGridOptions.rowHeight = 45;
        this.satisfactionGridOptions.headerHeight = 40;
        this.satisfactionHeaders = this.createSatisfactionHeaders();

        /*survey*/
        this.surveyGridOptions = <GridOptions>{};
        this.surveyGridOptions.rowHeight = 45;
        this.surveyGridOptions.headerHeight = 40;
        this.surveyHeaders = this.createSurveyHeaders();

        /*section1*/
        this.section1GridOptions = <GridOptions>{};
        this.section1GridOptions.rowHeight = 45;
        this.section1GridOptions.headerHeight = 40;
        this.section1Headers = this.createSection1Headers();

        /*section2*/
        this.section2GridOptions = <GridOptions>{};
        this.section2GridOptions.rowHeight = 45;
        this.section2GridOptions.headerHeight = 40;
        this.section2Headers = this.createSection2Headers();


        //editing
        if (!isNaN(this.assessmentId)) {

            this.showAssessmentPreview = true;
            //come from preview assessment
            if (this._Globals.previewAssessmentId != undefined) {
                console.log('current Editing Assessment', this._Globals.currentEditingAssessment);
                let data = this._Globals.currentEditingAssessment;
                this.loading = false;

                this.majorVersion = data.MajorVersion;
                this.minorVersion = data.MinorVersion;
                this.assessmentPrice = data.Price;
                this.name = data.Name;
                this.nicheId = data.NicheName;
                this.showAssessment360 = data.ShowAssessment360;

                if (this._Globals.pagesArr.length > 0) this.pagesArr = this._Globals.pagesArr;
                

                if (data.ReportTemplates.length > 0) {
                    this.coachTemplateId = this.findTemplateId(data.ReportTemplates, 2);
                    this.clientTemplateId = this.findTemplateId(data.ReportTemplates, 3);
                    console.log('Templates', this.coachTemplateId, this.clientTemplateId);
                }

                if (data.EmailTemplates.length > 0) {
                    //this.invitation = this.findPurpose(data.EmailTemplates, 1);
                    //this.result = this.findPurpose(data.EmailTemplates, 2);
                    //this.reminder = this.findPurpose(data.EmailTemplates, 3);
                    //console.log('purposes', this.invitation, this.result, this.reminder);

                    /*find select active on template*/
                    //client 
                    this.clientInvitation = this.findTemplateActive(data.EmailTemplates, 3, 1);
                    if (this.clientInvitation == 0) {
                        $('#clientInvitation :nth-child(1)').prop('selected', true);
                    } else {
                        $("#clientInvitation").val(this.clientInvitation);
                    }

                    this.clientReminder = this.findTemplateActive(data.EmailTemplates, 3, 3);
                    if (this.clientReminder == 0) $('#clientReminder :nth-child(1)').prop('selected', true);

                    this.clientResult = this.findTemplateActive(data.EmailTemplates, 3, 2);
                    if (this.clientResult == 0) $('#clientResult :nth-child(1)').prop('selected', true);

                    this.clientResultAvailable = this.findTemplateActive(data.EmailTemplates, 3, 4);
                    if (this.clientResultAvailable == 0) $('#clientResultAvailable :nth-child(1)').prop('selected', true);

                    //rater
                    this.raterInvitation = this.findTemplateActive(data.EmailTemplates, 4, 1);
                    if (this.raterInvitation == 0) $('#raterInvitation :nth-child(1)').prop('selected', true);

                    this.raterReminder = this.findTemplateActive(data.EmailTemplates, 4, 3);
                    if (this.raterReminder == 0) $('#raterReminder :nth-child(1)').prop('selected', true);

                    //coach
                    this.coachResult = this.findTemplateActive(data.EmailTemplates, 2, 2);
                    if (this.coachResult == 0) $('#coachResult :nth-child(1)').prop('selected', true);
                }



                //setting the regular, satisfaction and survey questions from preview assessment
                if (data.Sections.length >= 1)
                    this.regular_questions = data.Sections[0].Questions;
                if (data.Sections.length >= 2)
                    this.satisfaction_questions = data.Sections[1].Questions;
                if (data.Sections.length >= 3)
                    this.survey_questions = data.Sections[2].Questions;

                //setting the section 1 and section2 questions from preview assessment
                if (data.Sections.length >= 4)
                    this.section1_questions = data.Sections[3].Questions;
                if (data.Sections.length >= 5)
                    this.section2_questions = data.Sections[4].Questions;


                //setting the regular, satisfaction and survey questions from preview assessment
                if (data.Sections.length >= 1) {
                    let regularSection = {
                        "ChoiceSetId": data.Sections[0].ChoiceSetId,
                        "Id": data.Sections[0].Id,
                        "Order": data.Sections[0].Id,
                        "Type": 1
                    }
                    this.regularSection = regularSection;
                    console.log('regularSection', regularSection);
                }

                if (data.Sections.length >= 2) {
                    let satisfactionSection = {
                        "ChoiceSetId": data.Sections[1].ChoiceSetId,
                        "Id": data.Sections[1].Id,
                        "Order": data.Sections[1].Id,
                        "Type": 2
                    }
                    this.satisfactionSection = satisfactionSection;
                    console.log('satisfactionSection', satisfactionSection);
                }

                if (data.Sections.length >= 3) {
                    let surveySection = {
                        "ChoiceSetId": data.Sections[2].ChoiceSetId,
                        "Id": data.Sections[2].Id,
                        "Order": data.Sections[2].Id,
                        "Type": 3
                    }
                    this.surveySection = surveySection;
                    console.log('surveySection', surveySection);
                }

                //setting the section 1 and section2 questions from preview assessment
                if (data.Sections.length >= 4) {
                    let section1 = {
                        "ChoiceSetId": data.Sections[3].ChoiceSetId,
                        "Id": data.Sections[3].Id,
                        "Order": data.Sections[3].Id,
                        "Type": 4
                    }
                    this.section1 = section1;
                    console.log('section 1', section1);
                }

                if (data.Sections.length >= 5) {
                    let section2 = {
                        "ChoiceSetId": data.Sections[2].ChoiceSetId,
                        "Id": data.Sections[4].Id,
                        "Order": data.Sections[4].Id,
                        "Type": 5
                    }
                    this.section2 = section2;
                    console.log('section 2', section2);
                }


                //setting the deleted questions from preview mode for regular, satisfaction and survey section
                this.deleted_regular_questions = this._Globals.regularDeleted;
                this.deleted_satisfaction_questions = this._Globals.satisfactionDeleted;
                this.deleted_survey_questions = this._Globals.surveyDeleted;

                //setting the deleted questions from preview mode for section 1 and 2
                this.deleted_section1_questions = this._Globals.section1Deleted;
                this.deleted_section2_questions = this._Globals.section2Deleted;

                this.setTemplatesSelects([
                    'clientInvitation', 'clientReminder', 'clientResult', 'clientResultAvailable', 'clientTemplateId',
                    'raterInvitation', 'raterReminder',
                    'coachResult', 'coachTemplateId'
                ]);

            } else {
                //new or edit
                this._AdminService.getAssessment(this.assessmentId).subscribe((data: any) => {
                    console.log('getAssessment', data.result.Data);
                    console.log('data', JSON.parse(data.result.Data));

                    if (this._Globals.validationToken(data.result.Result)) {

                        let _data = JSON.parse(data.result.Data);
                        console.log('successfully loaded');
                        this.loading = false;

                        this.majorVersion = _data.MajorVersion;
                        this.minorVersion = _data.MinorVersion;
                        this.assessmentPrice = _data.Price;
                        this.name = _data.Name;
                        this.nicheName = _data.NicheName;
                        this.showAssessment360 = _data.Is360;

                        this.emailTemplates = _data.EmailTemplates;

                        //setting by default the content of custom pages
                        this.getAssessmentPageByUserType(this.pageTypes[0].Id, "en", this.currentPageSelectedType);
                        this.getAssessmentPageByUserType(this.pageTypes[1].Id, "en", this.currentPageSelectedType);

                        /*find select active on template*/
                        //client 
                        this.clientInvitation = this.findTemplateActive(this.emailTemplates, 3, 1);
                        if (this.clientInvitation == 0) this.clientInvitation = this.clientInvitations[0].Id;

                        this.clientReminder = this.findTemplateActive(this.emailTemplates, 3, 3);
                        if (this.clientReminder == 0) this.clientReminder = this.clientReminders[0].Id;

                        this.clientResult = this.findTemplateActive(this.emailTemplates, 3, 2);
                        if (this.clientResult == 0) this.clientResult = this.clientResults[0].Id;

                        this.clientResultAvailable = this.findTemplateActive(this.emailTemplates, 3, 4);
                        if (this.clientResultAvailable == 0) this.clientResultAvailable = this.clientResultsAvailable[0].Id;

                        //rater
                        this.raterInvitation = this.findTemplateActive(this.emailTemplates, 4, 1);
                        if (this.raterInvitation == 0) this.raterInvitation = this.raterInvitations[0].Id;

                        this.raterReminder = this.findTemplateActive(this.emailTemplates, 4, 3);
                        if (this.raterReminder == 0) this.raterReminder = this.raterReminders[0].Id;

                        //coach
                        this.coachResult = this.findTemplateActive(this.emailTemplates, 2, 2);
                        if (this.coachResult == 0) this.coachResult = this.coachResults[0].Id;


                        if (_data.Sections.length == 0) {
                            this.toastr.error('No choices', 'ELI');
                        } else {

                            //setting  the choice set value selected for regular and satisfaction
                            this.rChoiceSet = parseInt(_data.Sections[0].ChoiceSetId);
                            this.sChoiceSet = parseInt(_data.Sections[1].ChoiceSetId);


                            //check if the assessment has 360 section
                            //setting the choice set value selected for section 1 and 2
                            if (_data.Is360) {
                                this.section1currentChoiceSet = parseInt(_data.Sections[3].ChoiceSetId);
                                this.section2currentChoiceSet = parseInt(_data.Sections[4].ChoiceSetId);
                            }


                            if (_data.ReportTemplates.length > 0) {
                                this.coachTemplateId = this.findTemplateId(_data.ReportTemplates, 2);
                                this.clientTemplateId = this.findTemplateId(_data.ReportTemplates, 3);
                                console.log('Templates', this.coachTemplateId, this.clientTemplateId);
                            }

                            if (_data.EmailTemplates.length > 0) {
                                this.invitation = this.findPurpose(_data.EmailTemplates, 1);
                                this.result = this.findPurpose(_data.EmailTemplates, 2);
                                this.reminder = this.findPurpose(_data.EmailTemplates, 3);
                                console.log('purposes', this.invitation, this.result, this.reminder);
                            }

                            //setting the regular, satisfaction and survey questions
                            if (_data.Sections.length >= 1)
                                this.regular_questions = _data.Sections[0].Questions;
                            if (_data.Sections.length >= 2)
                                this.satisfaction_questions = _data.Sections[1].Questions;
                            if (_data.Sections.length >= 3)
                                this.survey_questions = _data.Sections[2].Questions;

                            //setting the section 1 and 2 questions
                            if (_data.Sections.length >= 4)
                                this.section1_questions = _data.Sections[3].Questions;
                            if (_data.Sections.length >= 5)
                                this.section2_questions = _data.Sections[4].Questions;


                            //setting the regular, satisfaction and survey questions
                            if (_data.Sections.length >= 1) {
                                let regularSection = {
                                    "ChoiceSetId": _data.Sections[0].ChoiceSetId,
                                    "Id": _data.Sections[0].Id,
                                    "Order": _data.Sections[0].Id,
                                    "Type": 1
                                }
                                this.regularSection = regularSection;
                                console.log('regularSection', regularSection);
                            }

                            if (_data.Sections.length >= 2) {
                                let satisfactionSection = {
                                    "ChoiceSetId": _data.Sections[1].ChoiceSetId,
                                    "Id": _data.Sections[1].Id,
                                    "Order": _data.Sections[1].Id,
                                    "Type": 2
                                }
                                this.satisfactionSection = satisfactionSection;
                                console.log('satisfactionSection', satisfactionSection);
                            }


                            if (_data.Sections.length >= 3) {
                                let surveySection = {
                                    "ChoiceSetId": _data.Sections[2].ChoiceSetId,
                                    "Id": _data.Sections[2].Id,
                                    "Order": _data.Sections[2].Id,
                                    "Type": 3
                                }
                                this.surveySection = surveySection;
                                console.log('surveySection', surveySection);
                            }

                            if (_data.Is360) {
                                //setting the section 1 and 2 questions
                                if (_data.Sections.length >= 3) {
                                    let section1 = {
                                        "ChoiceSetId": _data.Sections[3].ChoiceSetId,
                                        "Id": _data.Sections[3].Id,
                                        "Order": _data.Sections[3].Id,
                                        "Type": 4
                                    }
                                    this.section1 = section1;
                                    console.log('section1', section1);
                                }

                                if (_data.Sections.length >= 4) {
                                    let section2 = {
                                        "ChoiceSetId": _data.Sections[4].ChoiceSetId,
                                        "Id": _data.Sections[4].Id,
                                        "Order": _data.Sections[4].Id,
                                        "Type": 5
                                    }
                                    this.section2 = section2;
                                    console.log('section2', section2);
                                }
                            }
                        }
                    }
                });
            }
        } else {
            //new assessment
            this.newAssessment = true;
            this.loading = false; 
        }
    }

    getLanguages() {
        this._AdminService.getLanguages().subscribe((data: any) => {
            console.log('response_getLanguages', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                this.languages = _data;
            } 
        });
    }

    getPageTypes() {
        this._AdminService.getPageTypes().subscribe((data: any) => {
            console.log('response_getPageTypes', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                this.pageTypes = _data;
            } 
        });
    }

    getTemplateFields() {
        this._AdminService.getTemplateFields().subscribe(data => {
            console.log('response_GetTemplateFields', data.result);
            this.templateFields = data.result;
        });
    }

    insertCustomFields(fieldName: string) {
        var range = this.editor.getSelection();
        if (range) {
            if (range.length == 0) {
                console.log('User cursor is at index', range.index);
            } else {
                var text = this.editor.getText(range.index, range.length);
                console.log('User has highlighted: ', text);
            }
            this.editor.insertText(range.index, `{${fieldName}}`, 'bold', true);

        } else {
            console.log('User cursor is not in editor');

            var length = this.editor.getLength();

            this.editor.insertText(length - 1, `{${fieldName}}`, 'bold', true);
        }

    }

    createInstance(editorInstance) {
        this.editorInstance = editorInstance;
    }

    onContentChanged({ html, text }) {
        //console.log('quill content is changed!', quill, html, text);
        this.htmlBody = html;
        this.text = text;
        console.log('html body', this.htmlBody);

        console.log("pagesArr["+this.pos+"].content = ", this.htmlBody);
        this.pagesArr[this.pos].Content = this.htmlBody;
    }

    logSelection($event: any) {
        this.range = $event.range;
        console.log('$event', $event);
        console.log('range', this.range);
        this.createInstance($event.editor);
    }

    addBindingCreated(quill) {
        quill.keyboard.addBinding({
            key: 'b'
        }, (range, context) => {
            console.log('KEYBINDING B', range, context);
        });

        quill.keyboard.addBinding({
            key: 'B',
            shiftKey: true
        }, (range, context) => {
            console.log('KEYBINDING SHIFT + B', range, context);
        });
    }

    onEditorBlured(quill) {
        console.log('editor blur!', quill);
    }

    onEditorFocused(quill) {
        console.log('editor focus!', quill);
    }

    onEditorCreated(quill) {
        this.editor = quill;
        console.log('quill is ready! this is current quill instance object', quill);
        this.createInstance(quill.clipboard.quill);
    }

    public options: Object = {
        charCounterCount: true,
        toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertVideo', 'embedly', 'insertFile', 'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'spellChecker', 'help', 'html', '|', 'undo', 'redo', 'my_dropdown']
    };

    getAssessmentPage(pageType, language) {

        let pageObj = new PageObjDto();
        pageObj.AssessmentId = this.assessmentId;
        pageObj.PageType = pageType;
        pageObj.Language = language;

        let exist = this.existInArray(pageObj);
        if (!exist) {
            this._AssessmentsService.getAssessmentPage(this.assessmentId, pageType, language).subscribe((data: any) => {
                console.log('response_getAssessmentPage', data);
                if (this._Globals.validationToken(data.result.Result)) {
                    let _data = JSON.parse(data.result.Data);
                    console.log('_data', _data);
                    if (!isNull(_data)) {
                        this.editorContent = _data.Content;
                    } else {
                        this.editorContent = "";
                    }

                    this.pageSelected(pageType, language, this.editorContent);

                }
            });
        } else {
            console.log('this page is already loaded');
            this.editorContent = this.pagesArr[this.pos].Content;

        }

    }

    getAssessmentPageByUserType(pageType, language, userType) {

        let pageObj = new PageObjDto();
        pageObj.AssessmentId = this.assessmentId;
        pageObj.PageType = pageType;
        pageObj.Language = language;
        pageObj.UserType = userType;

        if (!isNaN(this.assessmentId)) {
            let exist = this.existInArray(pageObj);
            if (!exist) {
                this._AssessmentsService.getAssessmentPageByUserType(this.assessmentId, pageType, language, userType).subscribe((data: any) => {
                    console.log('response_getAssessmentPage', data);
                    if (this._Globals.validationToken(data.result.Result)) {
                        if (data.result.Result != 0) {
                            let _data = JSON.parse(data.result.Data);
                            console.log('_data', _data);
                            if (!isNull(_data)) {
                                this.editorContent = _data.Content;
                            } else {
                                this.editorContent = "";
                            }

                            this.pageSelected(pageType, language, this.editorContent);
                        } else {
                            console.log('service response 0');
                        }
                    }
                });
            } else {
                console.log('this page is already loaded');
                this.editorContent = this.pagesArr[this.pos].Content;
            }
        } else {
            this.pageSelected(pageType, language, "");
        }



    }

    pageSelected(pageType, language, content) {

        let page = new PageObjDto();
        page.AssessmentId = this.assessmentId;
        page.PageType = pageType;
        page.Language = language;
        page.Content = content;
        page.UserType = this.currentPageSelectedType;

        console.log('selected PageObjDto', page);


        this.addNewPageToArr(page);
    }

    pageSelectedType(type:number) {
        this.currentPageSelectedType = type;

        $('#pageType option').eq(0).prop('selected', true);
        $('#language option').eq(0).prop('selected', true);

        let pageType = $('#pageType').val();
        let language = $('#language').val();
        console.log(type);
        this.getAssessmentPageByUserType(pageType, language, this.currentPageSelectedType);        
    }

    findTemplateActive(arrayToFind, userType, purpose) {
        var i;
        for (i = 0; i < arrayToFind.length; i++) {
            if (JSON.stringify(arrayToFind[i].UserType) === JSON.stringify(userType)) {
                if (JSON.stringify(arrayToFind[i].Purpose) === JSON.stringify(purpose)) {
                    console.log(`id of item active for ${userType}, ${purpose}:`, arrayToFind[i].TemplateId);
                    return arrayToFind[i].TemplateId;
                }
            }
        }
        console.log('not founded');
        return 0;
    }

    GetChoiceSets(sectionType: number) {
        this._AdminService.getChoiceSets(sectionType).subscribe(data => {
            console.log('response_getChoiceSets', data);
            if (sectionType == 1) {
                this.regularChoiceSets = data.result;
                this.rChoiceSet = data.result[0].Id;
                console.log('regularChoiceSetDefault', this.rChoiceSet);
            }
            if (sectionType == 2) {
                this.satisfactionChoiceSets = data.result;
                this.sChoiceSet = data.result[0].Id;
                console.log('satisfactionChoiceSetDefault', this.sChoiceSet);
            }
            if (sectionType == 4) {
                this.section1ChoiceSets = data.result;
                this.section1currentChoiceSet = data.result[0].Id;
                console.log('section1ChoiceSetDefault', this.section1currentChoiceSet);
            }
            if (sectionType == 5) {
                this.section2ChoiceSets = data.result;
                this.section2currentChoiceSet = data.result[0].Id;
                console.log('section2ChoiceSetDefault', this.section2currentChoiceSet);
            }
        });
    }


    findTemplateId(ReportTemplates, userType:number) {
        for (var i = 0; i < ReportTemplates.length; i++) {
            if (ReportTemplates[i].UserType == userType) {
                return ReportTemplates[i].TemplateId;
            }
        }
        return "NotFounded";
    }

    findPurpose(emailTemplates, purposeToFind) {
        for (var i = 0; i < emailTemplates.length; i++) {
            if (emailTemplates[i].Purpose == purposeToFind) {
                return emailTemplates[i].TemplateId;
            }
        }
        return "NotFounded";
    }

    getNiches() {
        this._AdminService.getNiches().subscribe((data: any) => {
            console.log('Get Niches', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.niches = _data;
            }
        });
    }

    getEmailTemplatesByPurpose(purpose: number) {
        this._TemplatesService.getEmailTemplatesByPurpose(purpose).subscribe((data: any) => {
            console.log('response_GetEmailTemplatesByPurpose ' + purpose, data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                switch (purpose) {
                    case 1: {
                        this.invitations = _data;
                        break;
                    }

                    case 2: {
                        this.results = _data;
                        break;
                    }

                    case 3: {
                        this.reminders = _data;
                        break;
                    }
                }
            }
        })
    }

    getEmailTemplatesByUserTypeByPurpose(userType: number, purpose: number) {
        this._TemplatesService.getEmailTemplatesByUserTypeByPurpose(userType, purpose).subscribe((data: any) => {
            console.log('response__GetEmailTemplatesByUserTypeByPurpose ' + userType + ' ' + purpose, data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);

                switch (userType) {
                    case 3: {
                        switch (purpose) {
                            case 1: {
                                this.clientInvitations = _data;
                                break;
                            }

                            case 2: {
                                this.clientResults = _data;
                                break;
                            }

                            case 3: {
                                this.clientReminders = _data;
                                break;
                            }

                            case 4: {
                                this.clientResultsAvailable = _data;
                                break;
                            }
                        }
                        break;
                    }

                    case 4: {
                        switch (purpose) {
                            case 1: {
                                this.raterInvitations = _data;
                                break;
                            }

                            case 2: {
                                    this.raterResults = _data;
                                break;
                            }

                            case 3: {
                                this.raterReminders = _data;
                                break;
                            }
                        }
                        break;
                    }

                    case 2: {
                        switch (purpose) {
                            case 1: {
                                this.coachInvitations = _data;
                                break;
                            }

                            case 2: {
                                this.coachResults = _data;
                                break;
                            }

                            case 3: {
                                this.coachReminders = _data;
                                break;
                            }
                        }
                        break;
                    }
                }

                if (this.newAssessment) {
                    setTimeout(() => {
                        //setting the first option at all of the selects
                        $('#clientInvitation :nth-child(1)').prop('selected', true);
                        $('#clientReminder :nth-child(1)').prop('selected', true);
                        $('#clientResult :nth-child(1)').prop('selected', true);
                        $('#clientResultAvailable :nth-child(1)').prop('selected', true);
                        $('#clientTemplateId :nth-child(1)').prop('selected', true);

                        $('#raterInvitation :nth-child(1)').prop('selected', true);
                        $('#raterReminder :nth-child(1)').prop('selected', true);

                        $('#coachResult :nth-child(1)').prop('selected', true);
                        $('#coachTemplateId :nth-child(1)').prop('selected', true); 
                    }, 10);
                }

            }
        })
    }


  removeTag(index, event: any) {
      //console.log(event);
      //event.target.parentNode.remove();

      this.tags.splice(index, 1);
      console.log(this.tags);
    }

  removeTR(index, arrayName) {
      //console.log(event);
      //event.target.parentNode.parentElement.remove();
      arrayName.splice(index, 1);
      console.log(arrayName);
  }

  moveUp(index, arrayName) {
      if (index > 0) {
          const tmp = arrayName[index - 1];
          arrayName[index - 1] = arrayName[index];
          arrayName[index] = tmp;
      }
  }

  moveDown(index, arrayName) {
      if (index + 1 == arrayName.length) {
          return;
      }
      if (index < arrayName.length) {
          const tmp = arrayName[index + 1];
          arrayName[index + 1] = arrayName[index];
          arrayName[index] = tmp;
      }
  }

  addTag(tag: string) {
      let split_tags = tag.split(',');
      for (var i = 0; i < split_tags.length; i++) {
          //tag = tag.replace(" ", "_");
          var exist = this.tags.indexOf(split_tags[i]);
          if (exist != -1) {
              //alert("This Tag is already exist");
              //return;
          } else {
              this.tags.push(split_tags[i]);
              console.log(this.tags);
              $('#newTag').val('');
          }

      }
      
  }

  preventSpace(value: string, event: any) {
      if (value == null || value == "") {
          if (event.keyCode == 32) {
              return false;
          }
      }
      if (value == " ") {
          let id = event.target.id;
          $('#'+id+'').val('');
      }
  }

  preventLetters(event: any) {
      if (event.which < 48 || event.which > 57) {
          event.preventDefault();
          console.log('');
      }
  }

  generateSectionsArray():any[] {
      let sections: any[] = [];
      //this.removeTextFromQuestions(this.regular_questions);
      //this.removeTextFromQuestions(this.deleted_regular_questions);
      if (this.regularSection == undefined) {
          let newSection = {
              "Id": 0,
              "Order": 1,
              "Type": 1,
              "Questions": []
          }
          this.regularSection = newSection;
      }
      if (!this.excludeDeleted) {
          this.regularSection.Questions = this.regular_questions.concat(this.deleted_regular_questions);          
      } else {
          this.regularSection.Questions = this.regular_questions;
          this._Globals.regularDeleted = this.deleted_regular_questions;
      }

      if (this.rChoiceSet != undefined) {
          this.regularSection.ChoiceSetId = this.rChoiceSet;
      } else {
          $('#rChoiceSet').val();
      }
      sections.push(this.regularSection);
      
      //this.removeTextFromQuestions(this.section2_questions);
      //this.removeTextFromQuestions(this.deleted_section2_questions);
      if (this.satisfactionSection == undefined) {
          let newSection = {
              "Id": 0,
              "Order": 2,
              "Type": 2,
              "Questions": []
          }
          this.satisfactionSection = newSection;
      }
      if (!this.excludeDeleted) {
          this.satisfactionSection.Questions = this.satisfaction_questions.concat(this.deleted_satisfaction_questions);
      } else {
          this.satisfactionSection.Questions = this.satisfaction_questions;
          this._Globals.satisfactionDeleted = this.deleted_satisfaction_questions;
      }
      if (this.sChoiceSet != undefined) {
          this.satisfactionSection.ChoiceSetId = this.sChoiceSet;
      } else {
          $('#sChoiceSet').val();
      }
      sections.push(this.satisfactionSection);

      //this.removeTextFromQuestions(this.survey_questions);
      //this.removeTextFromQuestions(this.deleted_survey_questions);
      if (this.surveySection == undefined)
      {
          let newSection = {
              "Id": 0,
              "Order": 3,
              "Type": 3,
              "Questions": [],
              "ChoiceSetId": 1
          }
          this.surveySection = newSection;
      }
      if (!this.excludeDeleted) {
          this.surveySection.Questions = this.survey_questions.concat(this.deleted_survey_questions);
      } else {
          this.surveySection.Questions = this.survey_questions;
          this._Globals.surveyDeleted = this.deleted_survey_questions;
      }
      sections.push(this.surveySection);

      if (this.showAssessment360) {

          if (this.section1 == undefined) {
              let newSection = {
                  "Id": 0,
                  "Order": 4,
                  "Type": 4,
                  "Questions": []
              }
              this.section1 = newSection;
          }
          if (!this.excludeDeleted) {
              this.section1.Questions = this.section1_questions.concat(this.deleted_section1_questions);
          } else {
              this.section1.Questions = this.section1_questions;
              this._Globals.section1Deleted = this.deleted_section1_questions;
          }
          if (this.section1currentChoiceSet != undefined) {
              this.section1.ChoiceSetId = this.section1currentChoiceSet;
          } else {
              $('#section1currentChoiceSet').val();
          }
          sections.push(this.section1);

          //this.removeTextFromQuestions(this.section2_questions);
          //this.removeTextFromQuestions(this.deleted_section2_questions);
          if (this.section2 == undefined) {
              let newSection = {
                  "Id": 0,
                  "Order": 5,
                  "Type": 5,
                  "Questions": []
              }
              this.section2 = newSection;
          }
          if (!this.excludeDeleted) {
              this.section2.Questions = this.section2_questions.concat(this.deleted_section2_questions);
              if (this.section2currentChoiceSet != undefined) {
                  this.section2.ChoiceSetId = this.section2currentChoiceSet;
              }
          } else {
              this.section2.Questions = this.section2_questions;
              this._Globals.section2Deleted = this.deleted_section2_questions;
          }
              sections.push(this.section2);

      }

      console.log('sections', sections);      

      return sections;
  }

  removeTextFromQuestions(array: any[]) {
      for (var i = 0; i < array.length; i++){
          delete array[i].Text;
      }

  }

  selectSectionChoiceSet(sectionType: number, selectedChoiceSet: string) {
      console.log('sectionType', sectionType);
      console.log('selectedChoiceSet', selectedChoiceSet);

      switch (sectionType){
          case 1: {
              this.rChoiceSet = parseInt(selectedChoiceSet);
              break;
          }
          case 2: {
              this.sChoiceSet = parseInt(selectedChoiceSet);
              break;
          }
          case 4: {
              this.section1currentChoiceSet = parseInt(selectedChoiceSet);
              break;
          }
          case 5: {
              this.section2currentChoiceSet = parseInt(selectedChoiceSet);
              break;
          }
              
      }
  }
    
  saveAssessment() {

      
      console.log('save');
      let postSaveAssessmentData = this.getPostValues();

      //let name = $('#name').val();
      if (!isUndefined(postSaveAssessmentData)) {
          if (postSaveAssessmentData.name == "") {
              this.toastr.warning('Name field empty', 'ELI');
              return;
          }
      } else {
          return;
      }
      //let niche = $("#niche").val();
      //let major = $("#major").val();
      //let minor = $("#minor").val();
      //let sections = this.generateSectionsArray();

      //let id = 0;
      //if (this.assessmentId != null)
      //{
      //    id = this.assessmentId
      //}


      let canPreviewAssessment = true;
      postSaveAssessmentData.sections.forEach((section) => {
          if (section.Questions.length == 0) {
              canPreviewAssessment = false;
              return;
          }
      });

      if (!canPreviewAssessment) {
          this.toastr.warning('Please add at least one question for each section', 'ELI');
          return;
      }

      if (postSaveAssessmentData.major === "" || postSaveAssessmentData.minor === "") {
          this.toastr.warning('Please add at the assessment version.', 'ELI');
          return;
      }

      if (this.assessmentPrice == null || this.assessmentPrice.toString() == "") {
          this.toastr.warning('Please add at the price.', 'ELI');
          return;
      }

      console.log('postSaveAssessmentData', postSaveAssessmentData);

      let assessment = new SaveAssessmentsDto();

      assessment.id = postSaveAssessmentData.id;
      assessment.name = postSaveAssessmentData.name;
      assessment.niche = postSaveAssessmentData.niche;
      assessment.price = postSaveAssessmentData.price;
      assessment.majorVersion = postSaveAssessmentData.major;
      assessment.minorVersion = postSaveAssessmentData.minor;
      assessment.sections = postSaveAssessmentData.sections;
      assessment.reportTemplates = postSaveAssessmentData.reportTemplates;
      assessment.emailTemplates = postSaveAssessmentData.emailTemplates;
      assessment.is360 = postSaveAssessmentData.is360;

      console.log("assessment data", assessment);
      
      $('body').css('cursor', 'wait');
      this._AdminService.postSaveAssessments(assessment).subscribe(data => {
          console.log('response PostSaveAssessments', data);
          $('body').css('cursor', 'default');
          if (data.result.Result > 0) {
              this.toastr.success('Successfully saved.', 'ELI');
              this.router.navigate(['/app/admin_dashboard']);

              this.checkPages();

          } else {
              this.toastr.error('An error happend trying to save the assessment. Please try again.', 'ELI');
          }
          
      });

    }

    checkPages() {
        if (this.pagesArr.length > 0) {
            this.saveAssessmentPage(this.pagesArr[this.iteration]);
        }
    }

  getPostValues(): PostSaveAssessmentData {
      let postSaveAssessmentData = new PostSaveAssessmentData();
      postSaveAssessmentData.name = $('#name').val();
      postSaveAssessmentData.niche = $("#niche").val();
      postSaveAssessmentData.price = this.assessmentPrice;
      postSaveAssessmentData.major = $("#major").val();
      postSaveAssessmentData.minor = $("#minor").val();
      postSaveAssessmentData.sections = this.generateSectionsArray();

      postSaveAssessmentData.id = 0;
      if (this.assessmentId != null) {
          postSaveAssessmentData.id = this.assessmentId
      }

      //setting the report templates for preview mode
      let reportTemplates = [];
      let coachReportTemplate = {
          'TemplateId': parseInt($('#coachTemplateId').val()),
            'UserType': 2
      }

      let clientReportTemplate = {
          'TemplateId': parseInt($('#clientTemplateId').val()),
          'UserType': 3
      }
      reportTemplates.push(coachReportTemplate, clientReportTemplate);
      console.log('reportTemplates', reportTemplates);
      let validTemplates = this.validateTemplatesSelected(reportTemplates);
      if (validTemplates) postSaveAssessmentData.reportTemplates = reportTemplates;
      else {
          this.toastr.warning("Please set all of the assessment templates", "ELI");
          return;
      }

      //setting the email templates for preview mode
      let emailTemplates = [];

      //CLIENT
      emailTemplates.push({
          "TemplateId": parseInt($('#clientInvitation').val()),
          "Purpose": 1,
          "UserType": 3
      });

      emailTemplates.push({
          "TemplateId": parseInt($('#clientReminder').val()),
          "Purpose": 3,
          "UserType": 3
      });

      emailTemplates.push({
          "TemplateId": parseInt($('#clientResult').val()),
          "Purpose": 2,
          "UserType": 3
      });

      emailTemplates.push({
          "TemplateId": parseInt($('#clientResultAvailable').val()),
          "Purpose": 4,
          "UserType": 3
      });

      //RATER
      emailTemplates.push({
          "TemplateId": parseInt($('#raterInvitation').val()),
          "Purpose": 1,
          "UserType": 4
      });

      emailTemplates.push({
          "TemplateId": parseInt($('#raterReminder').val()),
          "Purpose": 3,
          "UserType": 4
      });

      //COACH
      emailTemplates.push({
          "TemplateId": parseInt($('#coachResult').val()),
          "Purpose": 2,
          "UserType": 2
      });


      console.log('emailTemplates', emailTemplates);
      validTemplates = this.validateTemplatesSelected(emailTemplates);
      if (validTemplates) postSaveAssessmentData.emailTemplates = emailTemplates;
      else {
          this.toastr.warning("Please set all of the assessment templates", "ELI");
          return;
      }
      
      postSaveAssessmentData.is360 = this.showAssessment360;

      return postSaveAssessmentData;
  }

  //"DisplayMode": 1,
  //"Questions": [],
  //"SectionId": 1,
  //"ShowIcons": false,
  //"SingleChoice": true

    validateTemplatesSelected(array: Array<any>): boolean {
        let valid = true;
        array.forEach((item) => {
            if (isNaN(item.TemplateId) || item.TemplateId == 0) {
                valid = false;
            }
        });
        return valid;
    }


  setSectionPreviewFormat(sectionId:number, section: any, displayMode: number, showIcons: boolean, singleChoice: boolean) {
      let newSection = section;

      newSection.DisplayMode = displayMode;
      newSection.SectionId = sectionId;
      newSection.ShowIcons = showIcons;
      newSection.SingleChoice = singleChoice;
      //delete newSection.Order;
      //delete newSection.Type;

      newSection.Questions.forEach((x) => {
          x.Answer = 0;
          //delete x.Order;
          //delete x.IsTestQuestion;
          //delete x.Status;
          
      });
      //console.log('newSection', newSection);
  }

  generatePreviewSections(): any[] {
      let sections: any[] = [];

      let regularSection = this.regularSection;
      regularSection.Questions = this.regular_questions;
      this.setSectionPreviewFormat(1, regularSection, 1, false, true);
      sections.push(this.regularSection);

      let satisfactionSection = this.satisfactionSection;
      this.satisfactionSection.Questions = this.satisfaction_questions;
      this.setSectionPreviewFormat(2, satisfactionSection, 1, false, true);
      sections.push(this.satisfactionSection);

      let surveySection = this.surveySection;
      this.surveySection.Questions = this.survey_questions;
      this.setSectionPreviewFormat(3, surveySection, 2, false, false);
      sections.push(this.surveySection);

      if (this.showAssessment360) {

          this.section1.Questions = this.section1_questions;
          this.setSectionPreviewFormat(1, this.section1, 1, false, true);
          sections.push(this.section1);

          this.section2.Questions = this.section2_questions;
          this.setSectionPreviewFormat(2, this.section2, 1, false, true);
          sections.push(this.section2);
      }

      console.log('sections', sections);

      return sections;
    }

    validatePagesContent(): boolean {
        //this._Globals.instructionsPageContent = this.pagesArr.map(function (e) { return e; }).indexOf(1); //1 instructions page
        console.log('pagesArr', this.pagesArr);
        if (this.pagesArr.length == 0) {
            this.toastr.warning('Pages content can not be empty.', 'ELI');
            return false;
        } else {
            let currentSelectedLanguage = $('#language').val();
            if (isNull(currentSelectedLanguage)) currentSelectedLanguage = "en";

            if (this.pagesArr.length == 1) {
                if (this.pagesArr.findIndex(x => x.PageType == 1 && x.Language == currentSelectedLanguage) == -1) {
                    this.toastr.warning('Please set the content for "Instructions" page.', 'ELI');
                    return false;
                } else {
                    this._Globals.instructionsPageContent = this.pagesArr.find(x => x.PageType == 1).Content;
                }
            } else {
                if (this.pagesArr.findIndex(x => x.PageType == 2 && x.Language == currentSelectedLanguage) == -1) {
                    this.toastr.warning('Please set the content for "Thank You" page.', 'ELI');
                    return false;
                } else {
                    this._Globals.instructionsPageContent = this.pagesArr.find(x => x.PageType == 1).Content;
                    this._Globals.thankyouPageContent = this.pagesArr.find(x => x.PageType == 2).Content;
                    return true;
                }
            }
        }
        return true;
    }

    previewMode() {
        if (isNaN(this.assessmentId)) {
            this.assessmentId = 0;
        }

        this._Globals.previewAssessmentId = this.assessmentId;
        this._Globals.showAssessment360 = this.showAssessment360;
        const currentEditingAssessment = this.generateCurrentEditingAssesmentJson();
        this._Globals.currentEditingAssessment = currentEditingAssessment;
        this._Globals.pagesArr = this.pagesArr;

        if (!this.validatePagesContent()) {
            return;
        }

        console.log('globals', this._Globals);

        let sections = this.generatePreviewSections();

        let canPreviewAssessment = true;
        sections.forEach((section) => {
            if (section.Questions.length == 0) {
                canPreviewAssessment = false;
                return;
            }
        });

        if (!canPreviewAssessment) {
            this.toastr.warning('Please add at least one question for each section', 'ELI');
            return;
        }

        let previewAssessment = {
                "result": {
                    "Id": 0,
                    "Progress": {
                        "CurrentQuestion": 0,
                        "CurrentSection": 0
                    },
                    "Sections": sections
                }
        }
      
        this._Globals.previewModeJSON = previewAssessment;
      

        let previewAssessmentFinal = JSON.stringify(previewAssessment);
        console.log('preview Mode Assessment', previewAssessmentFinal);

        //assigned_assessment/:from/:id/:assignmentId/:name/:language/:fullName
        ///assigned_assessment/pending/42/432/Assessment%20Test/en
        let language = $('#language').val();
        if (isNull(language)) {
            language = 'en';
        }

        this._Globals.previewMode = true;
        this.router.navigate(['/app/assigned_assessment', 'eli_assessments', this.assessmentId, 0, currentEditingAssessment.Name, language]);
    }

  generateCurrentEditingAssesmentJson(): any {
      //flag to handle the deleted questions
      this.excludeDeleted = true;
      let postSaveAssessmentData = this.getPostValues();

      if (isUndefined(postSaveAssessmentData)) {
           return;
      }

      let emailTemplates = [];
      //client
      let clientInvitation = {
          "TemplateId": parseInt(this.clientInvitation),
          "Purpose": 1,
          "UserType": 3
      }
      let clientReminder = {
          "TemplateId": this.clientReminder,
          "Purpose": 3,
          "UserType": 3
      }
      let clientResult = {
          "TemplateId": this.clientResult,
          "Purpose": 2,
          "UserType": 3
      }
      let clientResultAvailable = {
          "TemplateId": this.clientResultAvailable,
          "Purpose": 4,
          "UserType": 3
      }

      //rater
      let raterInvitation = {
          "TemplateId": this.raterInvitation,
          "Purpose": 1,
          "UserType": 4
      }
      let raterReminder = {
          "TemplateId": this.raterReminder,
          "Purpose": 3,
          "UserType": 4
      }
      //coach
      let coachResult = {
          "TemplateId": this.coachResult,
          "Purpose": 2,
          "UserType": 2
      }
      emailTemplates.push(clientInvitation, clientReminder, clientResult, clientResultAvailable, raterInvitation, raterReminder, coachResult);
      console.log('emailTemplates', emailTemplates);
      

      let currentEditingAssessment = {
          "Id": postSaveAssessmentData.id,
          "Name": postSaveAssessmentData.name,
          "NicheName": postSaveAssessmentData.niche,
          "MajorVersion": parseInt(postSaveAssessmentData.major),
          "MinorVersion": parseInt(postSaveAssessmentData.minor),
          "Is360": postSaveAssessmentData.is360,
          "Price": postSaveAssessmentData.price,
          "Sections": postSaveAssessmentData.sections,
          "EmailTemplates": emailTemplates,
          "ReportTemplates": postSaveAssessmentData.reportTemplates,
          "ShowAssessment360": postSaveAssessmentData.is360
      }

      console.log('current Editing Assessment Data', JSON.stringify(currentEditingAssessment));
      return currentEditingAssessment;
    }

    getTemplatesByUserType(userType: number) {
        this._TemplatesService.getTemplatesByUserType(userType).subscribe((data: any) => {
            console.log('response_GetTemplatesByUserType ' + userType, data.result);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                switch (userType) {
                    case 2: {
                        // coach
                        this.coachReports = _data;
                        break;
                    }
                    case 3: {
                        // client
                        this.clientReports = _data;
                        break;
                    }
                }
            }            
        })
    }
	

  /*---------------------------------*/
  /*generic method for all ag-grids*/
  /*---------------------------------*/

  gridSize(count: number) {
      this.count = count;
      console.log('count', this.count);
      this.height = (this.count + 1) * 43;
  }

  sizeToFit(gridApi) {
      gridApi.sizeColumnsToFit();
      $('.ag-body-viewport').css('overflow', 'overlay');
  }

  move(arr, old_index, new_index) {
      while (old_index < 0) {
          old_index += arr.length;
      }
      while (new_index < 0) {
          new_index += arr.length;
      }
      if (new_index >= arr.length) {
          var k = new_index - arr.length;
          while ((k--) + 1) {
              arr.push(undefined);
          }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);

      //updating the new order
      for (var i = 0; i < arr.length; i++) {
          arr[i].Order = (i + 1);
      }

      return arr;
    }

    onResize(event: any) {
        if (event.currentTarget.innerWidth < 992) {
            $('#responsiveSelect option').eq(this.currentSelectedTab).prop('selected', true);
        } else {
            console.log('set tab selected');
            this.openTab(this.currentSelectedTab + '-menu' + this.currentSelectedTab);
            $('.desktopTabs ul li').removeClass('active');
            $('.desktopTabs ul li').eq(this.currentSelectedTab).addClass('active');

            switch (this.currentSelectedTab) {
                case 3:
                    $('#menu3 #tab1').addClass('active in');
                    break;
                case 4:
                    $('#menu4 #templatesTab1').addClass('active in');
                    break;
                case 5:
                    $('#pagesTab1').addClass('active in');
                    break;
            }

        }
    }

  openTab(menu: string) { 
      var res = menu.split("-");
      console.log(res);

      $('.tab-content div').removeClass('active in');
      $('#' + res[1]).addClass('active in');
      this.tabSelect(res[0]);

      if (res[0] == "5") {
          $('#pagesTab1').addClass('active in');
      }
  }
     
    tabSelect(index: any) {
        console.log(index);

        //this.currentSelectedTab = parseInt(index);

        switch (parseFloat(index)) {

            case 3: 
            case 3.1:
                $('#tab1').addClass('in active');
                $('#tab2').removeClass('in active');
                //setting the first tab selected
                $('#menu3 li').removeClass('in active');
                $('#menu3 li').eq(0).addClass('in active');
                $('#templatesTab1').addClass('active in');
                break;

            case 3.2:
                this.currentPageSelectedType = 3;
                $('#cPages li').removeClass('active');
                $('#cPages li').eq(0).addClass('active');

                if (this.pageTypes.length > 0) {
                    $('#pageType option').eq(0).prop('selected', true);
                    $('#language option').eq(0).prop('selected', true);

                    //this.getAssessmentPage(this.pageTypes[0].Id, "en");
                    this.getAssessmentPageByUserType(this.pageTypes[0].Id, "en", this.currentPageSelectedType);
                }
                break;

            case 4:
                $('#menu4 #templatesTab1').addClass('active in');
                $('#menu4 li').removeClass('active');
                $('#menu4 li').eq(0).addClass('active');
                break;

            case 5:
                this.getAssessmentPageByUserType(this.pageTypes[0].Id, 'en', 3);

                $('#pagesTab1').addClass('active in');
                $('#menu5 li').removeClass('active');
                $('#menu5 li').eq(0).addClass('active');

                $('#pageType option').eq(0).prop('selected', true);
                $('#language option').eq(0).prop('selected', true);
                break;
        }

        setTimeout(() => {
            if (index != 4 && index != 5 && index != "0") {
                let currentGridApi = this.getGridApiByType(index);
                this.sizeToFit(currentGridApi);      
            }
        }, 100);

        setTimeout(() => {
            console.log(this.checkTrue);
            console.log(this.checkfalse);

            for (var i = 0; i < this.checkTrue.length; i++) {
                $('#check' + this.checkTrue[i]).show();
            }

            for (var j = 0; j < this.checkfalse.length; j++) {
                $('#check' + this.checkfalse[j]).hide();
            }
        }, 500);
        
    }

    addNewPageToArr(pageObj: PageObjDto) {
        //create the procces to find the correcto obj

        console.log('addNewPageToArr()', this.pagesArr);

        if (this.pagesArr.length > 0) {

            let exist = this.existInArray(pageObj);

            //not exist add new
            if (exist) {
                this.editorContent = this.pagesArr[this.pos].Content;
            } else {
                this.pagesArr.push(pageObj);
                this.pos = this.pagesArr.length - 1;
                this.editorContent = pageObj.Content;
            }            
        }
        else
        {
            this.pagesArr.push(pageObj);
        }

        console.log('addNewPageToArr()', this.pagesArr);
        
    }

    existInArray(pageObj: PageObjDto): boolean {
        let exist = false;
        this.pos = 0;

        this.pagesArr.forEach((item, index) => {
            if (pageObj.PageType == item.PageType) {
                if (pageObj.Language == item.Language) {
                    if (pageObj.UserType == item.UserType) {
                        //item exist edit the content
                        exist = true;
                        this.pos = index;
                        return;
                    }
                }
            }
        });
        return exist;
    }

    saveAssessmentPage(pageObj: PageObjDto) {
        console.log('uploading iteration', this.iteration);
        this._AssessmentsService.postSaveAssessmentPage(pageObj).subscribe((data: any) => {
            console.log('response_saveAssessmentPage', data);
            console.log('uploaded successfully');
            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result === 1) {
                    this.iteration++;
                    if (this.iteration < this.pagesArr.length) {
                        console.log('uploading iteration +1', this.iteration);
                        this.saveAssessmentPage(this.pagesArr[this.iteration]);
                    } else {
                        console.log("all uploaded successfully");
                    }
                } else {
                    console.log("Server return 0");
                }
            } 
        });
    }

    

  getGridApiByType(index) {
      switch (parseFloat(index)) {
          case 0: {
              return this.regularGridApi;
          }
          case 1: {
              return this.satisfactionGridApi;
          }
          case 2: {
              return this.surveyGridApi;
          }
          case 3:
          case 3.1: {
              return this.section1GridApi;
          }
          case 3.2: {
              return this.section2GridApi;
          }
      } 
  }

  //deleteFromAgGrid(rowIndex: number, questionsArray: any[], gridApi:any ) {
  //    var model = gridApi.getModel();
  //    model.rowsToDisplay.splice(rowIndex, 1);
  //    console.log('question to delete', questionsArray[rowIndex]);
  //    questionsArray.splice(rowIndex, 1);
  //    let items = questionsArray;
  //    questionsArray = [];
  //    setTimeout(() => {
  //        questionsArray = items;
  //        console.log(questionsArray);
  //        gridApi.redrawRows();
  //    }, 100);
  //}



    /*---------------------------------------------*/
    /*---------QUESTIONS MODAL ag-grid--------------*/
    /*---------------------------------------------*/

  showQuestions(questionType: number) {
      this.currentQuestionType = questionType;
      this.questionType = this.getQuestiontype(questionType);
      this.getQuestions(questionType);
      $('#questionsModal').modal('show');
  }

  getQuestions(questionType: number) {
//<<<<<<< HEAD
//      this._GetQuestions.getQuestions(questionType).subscribe((data: any) => {
//          console.log('response_GetQuestions', data);
//          if (this._Globals.validationToken(data.result.Result)) {
//              let _data = JSON.parse(data.result.Data);
//              console.log('_data', _data);

//              this.questions = _data;
//              setTimeout(() => {
//                  this.sizeToFit(this.questionsGridApi);
//              }, 100);
//          }

//      });

//  }
      //=======
      this._AdminService.getQuestions(questionType).subscribe((data: any) => {
        console.log('response_getQuestions', data);
        if (this._Globals.validationToken(data.result.Result)) {
            let _data = JSON.parse(data.result.Data);

            this.questions = _data;
            console.log('questionType: ' + questionType, _data);
            setTimeout(() => {
                this.sizeToFit(this.questionsGridApi);
            }, 100);
        } 
    });
}

  getQuestiontype(type: number): string {
      switch (type) {
          case 1: {
              return 'Regular';
          }
          case 2: {
              return 'Satisfaction';
          }
          case 3: {
              return 'Survey';
          }
          case 4: {
              return 'Section 1';
          }
          case 5: {
              return 'Section 2';
          }
          default: {
              return '';
          }
      }
  }

  addQuestions() {
      let selectedQuestions = this.getSelectedRows();
      switch (this.currentQuestionType) {
          case 1: {
              this.setSelectedQuestions(selectedQuestions, this.regular_questions, this.regularGridApi, this.deleted_regular_questions);
              console.log('array', this.regular_questions);
              break;
          }
          case 2: {
              this.setSelectedQuestions(selectedQuestions, this.satisfaction_questions, this.satisfactionGridApi, this.deleted_satisfaction_questions);
              console.log('array', this.satisfaction_questions);
              break;
          }
          case 3: {
              this.setSelectedQuestions(selectedQuestions, this.survey_questions, this.surveyGridApi, this.deleted_survey_questions);
              console.log('array', this.survey_questions);
              break;
          }
          case 4: {
              this.setSelectedQuestions(selectedQuestions, this.section1_questions, this.section1GridApi, this.deleted_section1_questions);
              console.log('array', this.section1_questions);
              break;
          }
          case 5: {
              this.setSelectedQuestions(selectedQuestions, this.section2_questions, this.section2GridApi, this.deleted_section2_questions);
              console.log('array', this.section2_questions);
              break;
          }
      }
      $('#questionsModal').modal('hide');
  }

  setSelectedQuestions(selectedQuestions, array: any[], gridApi, deletedArray) {
      selectedQuestions.forEach((selectedRow, index) => {
          console.log('selectedRow index: ' + index, selectedRow);
          let currentQuestionId = selectedRow.Id;
          let pos = array.map(function (e) { return e.Id; }).indexOf(currentQuestionId);
          if (pos == -1) { 
              //set new order
              let order = array.length + 1;
              selectedRow.Order = order;

              array.push(selectedRow);
              //this.removeNewFromDeletedIfExist(deletedArray, currentQuestionId);
              let existInDeleted = this.existInDeletes(deletedArray, currentQuestionId);
              if (existInDeleted) {
                  selectedRow.Status = 1;
              }
              var res = gridApi.updateRowData({ add: [selectedQuestions[index]] });
          }
          
      });
      this.sizeToFit(gridApi);
  }

  existInDeletes(array: any[], newQuestionId: number): boolean {
      if (array.length > 0) {
          let pos = array.map(function (e) { return e.Id; }).indexOf(newQuestionId);
          if (pos != -1) {
              array.splice(pos, 1);
              console.log('deleted array', array);
              return true;
          } else {
              return false;
          }
          
      }
  }

  removeNewFromDeletedIfExist(array: any[], newQuestionId: number) {
      if (array.length > 0) {
          let pos = array.map(function (e) { return e.Id; }).indexOf(newQuestionId);
          if (pos != -1) {
              array.splice(pos, 1);
              console.log('deleted array', array);
          }
      }
  }

  getSelectedRows(): any {
      return this.questionsGridApi.getSelectedRows();
  }

  onQuestionsGridReady(params) {
      this.questionsGridApi = params.api;
      this.sizeToFit(this.questionsGridApi);
  }

  createModalHeaders() {
      let columnDefs = new Array();
      //console.log('header');
      let idHeader = {
          headerName: 'Id',
          field: 'Id',
          sort: 'asc',
          minWidth: 50,
          width: 50,
          hide: true,
          pinned: 'left',
          suppressSizeToFit: false,
          cellRenderer: function (params) {
              return params.value;
          }
      };
      columnDefs.push(idHeader);

      let nameHeader = {
          headerName: 'Text',
          field: 'Text',
          minWidth: 1000,
          width: 1000,
          suppressSizeToFit: true,
          cellRenderer: function (params) {
              return params.value;
          }
      };
      columnDefs.push(nameHeader);

      return columnDefs;
  }

  public onQuestionsRowClicked(e) {
      console.log(e);
      if (e.event.target !== undefined) {
          let data = e.data;
          switch (e.event.target.id) {
              case "editAction":
                  {
                      break;
                  }

              case "deleteAction":
                  {
                      break;
                  }
          }
      }
  }
    

     /*---------------------------------------------*/
    /*---------REGULAR QUESTIONS ag-grid------------*/
    /*---------------------------------------------*/

  onRegularGridReady(params) {
      this.regularGridApi = params.api;
      this.sizeToFit(this.regularGridApi);
  }

  createRegularHeaders() {
      let columnDefs = new Array();
      //console.log('header');

      //console.log('header');
      //let idHeader = {
      //    headerName: 'Id',
      //    field: 'Id',
      //    minWidth: 200,
      //    width: 200,
      //    hide: true,
      //    suppressSizeToFit: false,
      //    cellRenderer: function (params) {
      //        return params.value;
      //    }
      //};
      //columnDefs.push(idHeader);

      let actionsHeader = {
          headerName: 'Actions',
          field: '',
          width: 85,
          minWidth: 85,
          suppressSizeToFit: true,
          suppressSorting: true,
          suppressMenu: true,
          cellRenderer: function (params) {
              let content = '';

              content += '<i id="deleteRegular" class="material-icons custom-icons">delete</i>';

              return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

          }
      };
      columnDefs.push(actionsHeader);

      let positionHeader = {
          headerName: '',
          field: '',
          rowDrag: true,
          minWidth: 35,
          width: 35,
          suppressSizeToFit: false,
          cellRenderer: function (params) {
              //console.log(params);
              return parseInt(params.rowIndex) + 1;
          }
      };
      columnDefs.push(positionHeader);

      let nameHeader = {
          headerName: 'Text',
          field: 'Text',
          minWidth: 200,
          width: 200,
          suppressSizeToFit: false,
          cellRenderer: function (params) {
              return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
          }
      };
      columnDefs.push(nameHeader);

      let checkHeader = {
          headerName: 'Test Question',
          field: 'TestQuestion',
          minWidth: 90,
          width: 90,
          suppressSizeToFit: false,
          cellRenderer: function (params) {
              let checked = params.data.IsTestQuestion;
			  let rowIndex = params.node.rowIndex;
              if (checked) {
                  //return '<input type="checkbox" id="check" value="" checked>';
                  //return '<div style="padding-left: 0px !important;" class="checkbox"><input id="check' + rowIndex + '" type="checkbox" checked=""><label id="c' + rowIndex + '" for="check' + rowIndex + '"></label></div>';
                  return '<i id="check' + params.data.Id +'" class="material-icons">check</i>';
              } else {
                  //return '<input type="checkbox" id="check" value="">';
                  //return '<div style="padding-left: 0px !important;" class="checkbox"><input id="check'+rowIndex+'" type="checkbox" unchecked><label id="c'+rowIndex+'" for="check'+rowIndex+'"></label></div>';
                  return '<i id="check' + params.data.Id +'" class="material-icons" style="display:none;">check</i>';
              }
          }
      };
      columnDefs.push(checkHeader);

      return columnDefs;
    }

    updateRowEntry(gridApi: any, currentIndex: number, enText: string, IsTestQuestion: boolean) {
        var model = gridApi.getModel();
        var rowNode = model.rowsToDisplay[currentIndex];
        console.log("rowNode", rowNode);
        rowNode.setDataValue("Text", enText);

        let postrue = this.checkTrue.indexOf(rowNode.data.Id);
        if (postrue != -1) {
            this.checkTrue.splice(postrue, 1);
        } 
        let posfalse = this.checkfalse.indexOf(rowNode.data.Id);
        if (posfalse != -1) {
            this.checkfalse.splice(posfalse, 1);
        }
        


        if (IsTestQuestion) {
            $('#check' + rowNode.data.Id).show();
            this.checkTrue.push(rowNode.data.Id);
        } else {
            $('#check' + rowNode.data.Id).hide();
            this.checkfalse.push(rowNode.data.Id);
        }
    }

  public onRegularRowClicked(e) {
      console.log(e);
      let rowIndex = e.rowIndex;
      this.currentRowIndex = rowIndex;
      if (e.event.target !== undefined) {
          let data = e.data;
		  let checkboxrowindex = `c${rowIndex}`;

          switch (e.event.target.id) {

            case "deleteRegular":
                {
                    //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                    this.deleteRegular(rowIndex);
                    break;
                }
            case checkboxrowindex:
                {
                    //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                    this.setRegularCheckboxValue(rowIndex, data['IsTestQuestion']);
                    break;
                }
            default:
                    if (this._onRowDragEnter == undefined) {
                        this.editSelected(data['Id'], data['Text'], 1);
                    }
          }
      }
    }

    //type
    //1 regular
    //2 satisfaction
    //3 survey
    //4 section 1
    //5 section 2
    editSelected(id: number, text: string, type: number) {
        this.openModal('edit', type, id, text);
    }

    openModal(action, type, index?, text?: string) {
        console.log("Action: ", action);
        switch (type) {

            case 1:
            case 4:
                {
                    this.newRegularModal.show(text, this, action, index, type, false);
                    break;
                }
            case 2:
            case 5:
                {
                    this.newSatisfactionModal.show(text, this, action, index, type, false);
                    break;
                }
            case 3:
                {
                    this.newSurveyModal.show(text, this, action, index, false);
                    break;
                }
        }
    }

  setRegularCheckboxValue(index, value: boolean) {
      this.regular_questions[index].IsTestQuestion = !value;
      console.log(this.regular_questions[index]);
  }

  deleteRegular(rowIndex: number) {
      var model = this.regularGridApi.getModel();
      model.rowsToDisplay.splice(rowIndex, 1);
      console.log('question to delete', this.regular_questions[rowIndex]);

      //adding deleted question
      this.regular_questions[rowIndex].Status = 2;

      let currentQuestionId = this.regular_questions[rowIndex].Id;
      let pos = this.deleted_regular_questions.map(function (e) { return e.Id; }).indexOf(currentQuestionId);
      if (pos == -1) {
          this.deleted_regular_questions.push(this.regular_questions[rowIndex]);
      }
      console.log('deleted regular questions', this.deleted_regular_questions);

      //removing from regular questions array
      this.regular_questions.splice(rowIndex, 1);
      let items = this.regular_questions;
      this.regular_questions = [];
      setTimeout(() => {
          this.regular_questions = items;
          console.log('regular_questions',this.regular_questions);
          this.regularGridApi.redrawRows();
      }, 0);

      //this.deleteFromAgGrid(rowIndex, this.section1_questions, this.section1GridApi);
  }

  onRowDragEnter(e) {
      console.log("onRowDragEnter", e);
      this._onRowDragEnter = e.overIndex;
      console.log('old',this._onRowDragEnter + 1);
  }

  onRowDragEnd(e, array) {
      console.log('array', array);
      console.log("onRowDragEnd", e);
      this._onRowDragEnd = e.overIndex;
      array = this.move(array, this._onRowDragEnter, this._onRowDragEnd, );
      console.log('array', array);
      console.log('new', this._onRowDragEnd + 1);

      var model = this.regularGridApi.getModel();
      console.log(model);

      this.regularGridApi.redrawRows();
      this.satisfactionGridApi.redrawRows();
      this.surveyGridApi.redrawRows();

      this.section1GridApi.redrawRows();
      this.section2GridApi.redrawRows();

      setTimeout(() => {
          this._onRowDragEnter = undefined;
      },100);
      
  }

  /*---------------------------------------------*/
  /*------SATISFACTION QUESTIONS ag-grid----------*/
  /*---------------------------------------------*/

  onSatisfactionGridReady(params) {
      this.satisfactionGridApi = params.api
      this.sizeToFit(this.satisfactionGridApi);
      setTimeout(() => {
          $(".ag-floating-filter-input").attr("placeholder", "Filter");
      }, 100);
  }

  createSatisfactionHeaders() {
      let columnDefs = new Array();
      //console.log('header');
      //let idHeader = {
      //    headerName: 'Id',
      //    field: 'Id',
      //    minWidth: 200,
      //    width: 200,
      //    hide: true,
      //    suppressSizeToFit: false,
      //    cellRenderer: function (params) {
      //        return params.value;
      //    }
      //};
      //columnDefs.push(idHeader);

      let actionsHeader = {
          headerName: 'Actions',
          field: '',
          width:85,
          minWidth: 85,
          suppressSizeToFit: true,
          suppressSorting: true,
          suppressMenu: true,
          cellRenderer: function (params) {
              let content = '';

              content += '<i id="deleteSatisfaction" class="material-icons custom-icons">delete</i>';

              return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

          }
      };
      columnDefs.push(actionsHeader);

      let positionHeader = {
          headerName: '',
          field: '',
          rowDrag: true,
          minWidth: 35,
          width: 35,
          suppressSizeToFit: false,
          cellRenderer: function (params) {
              //console.log(params);
              return parseInt(params.rowIndex) + 1;
          }
      };
      columnDefs.push(positionHeader);

      let nameHeader = {
          headerName: 'Text',
          field: 'Text',
          minWidth: 200,
          width: 200,
          suppressSizeToFit: false,
          cellRenderer: function (params) {
              return params.value;
          }
      };
      columnDefs.push(nameHeader);

      let testHeader = {
          headerName: 'Test Question',
          field: 'TestQuestion',
          minWidth: 90,
          width: 90,
          suppressSizeToFit: false,
          cellRenderer: function (params) {
              let checked = params.data.IsTestQuestion;
			  let rowIndex = params.node.rowIndex;
              if (checked) {
                  //return '<input type="checkbox" id="check" value="" checked>';
                  //return '<div style="padding-left: 0px !important;" class="checkbox"><input id="check' + rowIndex + '" type="checkbox" checked=""><label id="c' + rowIndex + '" for="check' + rowIndex + '"></label></div>';
                  return '<i id="check' + params.data.Id + '" class="material-icons">check</i>';
              } else {
                  //return '<input type="checkbox" id="check" value="">';
                  //return '<div style="padding-left: 0px !important;" class="checkbox"><input id="check'+rowIndex+'" type="checkbox" unchecked><label id="c'+rowIndex+'" for="check'+rowIndex+'"></label></div>';
                  return '<i id="check' + params.data.Id + '" class="material-icons" style="display:none;">check</i>';
              }
	      }
      };
      columnDefs.push(testHeader);

      return columnDefs;
  }

  public onSatisfactionRowClicked(e) { 
      console.log(e);
      if (e.event.target !== undefined) {
          let data = e.data;
          let rowIndex = e.rowIndex;
          this.currentRowIndex = rowIndex;
		  let checkboxrowindex = `c${rowIndex}`;

          switch (e.event.target.id) {

              case "deleteSatisfaction":
                  {
                      //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                      this.deleteSatisfaction(rowIndex);
                      break;
                  }
			  case checkboxrowindex:
				  {
					  //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
						 this.setSatisfactionCheckboxValue(rowIndex, data['IsTestQuestion']);
					  break;
                  }
              default:
                  if (this._onRowDragEnter == undefined) {
                      this.editSelected(data['Id'], data['Text'], 2);
                  }
          }
      }
  }

  setSatisfactionCheckboxValue(index, value: boolean) {
      this.satisfaction_questions[index].IsTestQuestion = !value;
      console.log(this.satisfaction_questions[index]);
  }


  deleteSatisfaction(rowIndex: number) {
      var model = this.satisfactionGridApi.getModel();
      model.rowsToDisplay.splice(rowIndex, 1);
      console.log('question to delete', this.satisfaction_questions[rowIndex]);

      //adding deleted question
      this.satisfaction_questions[rowIndex].Status = 2;

      let currentQuestionId = this.satisfaction_questions[rowIndex].Id;
      let pos = this.deleted_satisfaction_questions.map(function (e) { return e.Id; }).indexOf(currentQuestionId);
      if (pos == -1) {
          this.deleted_satisfaction_questions.push(this.satisfaction_questions[rowIndex]);
      }
      console.log('deleted satisfaction questions', this.deleted_satisfaction_questions);

      this.satisfaction_questions.splice(rowIndex, 1);
      let items = this.satisfaction_questions;
      this.satisfaction_questions = [];
      setTimeout(() => {
          this.satisfaction_questions = items;
          console.log(this.satisfaction_questions);
          this.satisfactionGridApi.redrawRows();
      }, 0);
  }

  /*---------------------------------------------*/
  /*---------SURVEY QUESTIONS ag-grid------------*/
  /*---------------------------------------------*/

  onSurveyGridReady(params) {
      this.surveyGridApi = params.api;
      this.sizeToFit(this.surveyGridApi);
  }

  createSurveyHeaders() {
      let columnDefs = new Array();
      //console.log('header');
      //let idHeader = {
      //    headerName: 'Id',
      //    field: 'Id',
      //    minWidth: 200,
      //    width: 200,
      //    hide: true,
      //    suppressSizeToFit: false,
      //    cellRenderer: function (params) {
      //        return params.value;
      //    }
      //};
      //columnDefs.push(idHeader);
      let actionsHeader = {
          headerName: 'Actions',
          field: '',
          width: 85,
          minWidth: 85,
          suppressSizeToFit: true,
          suppressSorting: true,
          suppressMenu: true,
          cellRenderer: function (params) {
              let content = '';

              content += '<i id="deleteSurvey" class="material-icons custom-icons">delete</i>';

              return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

          }
      };
      columnDefs.push(actionsHeader);

      let positionHeader = {
          headerName: '',
          field: '',
          rowDrag: true,
          minWidth: 35,
          width: 35,
          suppressSizeToFit: false,
          cellRenderer: function (params) {
              return parseInt(params.rowIndex) + 1;
          }
      };
      columnDefs.push(positionHeader);

      let nameHeader = {
          headerName: 'Text',
          field: 'Text',
          minWidth: 200,
          width: 200,
          suppressSizeToFit: false,
          cellRenderer: function (params) {
              return params.value;
          }
      };
      columnDefs.push(nameHeader);

      let testHeader = {
          headerName: 'Test Question',
          field: 'TestQuestion',
          minWidth: 90,
          width: 90,
          suppressSizeToFit: false,
          cellRenderer: function (params) {
              let checked = params.data.IsTestQuestion;
			  let rowIndex = params.node.rowIndex;
              if (checked) {
                  //return '<input type="checkbox" id="check" value="" checked>';
                  //return '<div style="padding-left: 0px !important;" class="checkbox"><input id="check' + rowIndex + '" type="checkbox" checked=""><label id="c' + rowIndex + '" for="check' + rowIndex + '"></label></div>';
                  return '<i id="check' + params.data.Id + '" class="material-icons">check</i>';
              } else {
                  //return '<input type="checkbox" id="check" value="">';
                  //return '<div style="padding-left: 0px !important;" class="checkbox"><input id="check'+rowIndex+'" type="checkbox" unchecked><label id="c'+rowIndex+'" for="check'+rowIndex+'"></label></div>';
                  return '<i id="check' + params.data.Id + '" class="material-icons" style="display:none;">check</i>';
              }
		  }
      };
      columnDefs.push(testHeader);

      return columnDefs;
  }

  public onSurveyRowClicked(e) { 
      console.log(e);
      if (e.event.target !== undefined) {
          let data = e.data;
          let rowIndex = e.rowIndex;
          this.currentRowIndex = rowIndex;
		  let checkboxrowindex = `c${rowIndex}`;

          switch (e.event.target.id) {

              case "deleteSurvey":
                  {
                      //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                      this.deleteSurvey(rowIndex);
                      break;
                  }
			  case checkboxrowindex:
				  {
					  //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
						 this.setSurveyCheckboxValue(rowIndex, data['IsTestQuestion']);
					  break;
                  }
              default:
                  if (this._onRowDragEnter == undefined) {
                      this.editSelected(data['Id'], data['Text'], 3);
                  }
          }
      }
  }

  setSurveyCheckboxValue(index, value: boolean) {
      this.survey_questions[index].IsTestQuestion = !value;
      console.log(this.survey_questions[index]);
  }

  deleteSurvey(rowIndex) {
      var model = this.surveyGridApi.getModel();
      model.rowsToDisplay.splice(rowIndex, 1);
      console.log('question to delete', this.survey_questions[rowIndex]);

      //adding deleted question
      this.survey_questions[rowIndex].Status = 2;

      let currentQuestionId = this.survey_questions[rowIndex].Id;
      let pos = this.deleted_survey_questions.map(function (e) { return e.Id; }).indexOf(currentQuestionId);
      if (pos == -1) {
          this.deleted_survey_questions.push(this.survey_questions[rowIndex]);
      }
      console.log('deleted survey questions', this.deleted_survey_questions);
      this.survey_questions.splice(rowIndex, 1);
      let items = this.survey_questions;
      this.survey_questions = [];
      setTimeout(() => {
          this.survey_questions = items;
          console.log(this.survey_questions);
          this.surveyGridApi.redrawRows();
      }, 0);
  }

  ngOnDestroy() {
      let url = this.router.url.split('/');
      if (url[2] != "assigned_assessment"){
          console.log('this', this);
          this._Globals.currentEditingAssessment = undefined;
          this._Globals.previewAssessmentId = undefined;
          this._Globals.regularDeleted = [];
          this._Globals.satisfactionDeleted = [];
          this._Globals.surveyDeleted = [];
          console.log('GLOBALS', this._Globals);
      }

    }

    /*Assessment 360*/
    toggleAssessment360() {
        this.showAssessment360 = !this.showAssessment360;
        console.log(this.showAssessment360);
        if (this.showAssessment360) {
            $('.desktopTabs ul li').removeClass('active');
            this.openTab('3-menu3');
            this.currentSelectedTab = 4;
            //$('li').removeClass('active');
            setTimeout(() => {
                $('.desktopTabs ul li:nth-child(4)').addClass('active');
                $('#responsiveSelect :nth-child(4)').prop('selected', true);
                $('#section1').addClass('active');
            }, 250);
        } else {
            if (this.currentSelectedTab === 4) {
                this.openTab('0-menu0');
                $('li').removeClass('active');
                $('.desktopTabs ul li:first-child').addClass('active');
                $('#responsiveSelect :nth-child(0)').prop('selected', true);
                $('#section1').removeClass('active');
            }

            if (this.currentSelectedTab === 5) {
                this.getAssessmentPageByUserType(this.pageTypes[0].Id, 'en', 3);
                $('#menu5 li').eq(0).addClass('active');
            }
        }
    }

    /*---------------------------------------------*/
    /*---------SECTION1 QUESTIONS ag-grid------------*/
    /*---------------------------------------------*/

    onSection1GridReady(params) {
        this.section1GridApi = params.api;
        this.sizeToFit(this.section1GridApi);
    }

    createSection1Headers() {
        let columnDefs = new Array();
        //console.log('header');

        //console.log('header');
        //let idHeader = {
        //    headerName: 'Id',
        //    field: 'Id',
        //    minWidth: 200,
        //    width: 200,
        //    hide: true,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(idHeader);

        let actionsHeader = {
            headerName: 'Actions',
            field: '',
            width: 85,
            minWidth: 85,
            suppressSizeToFit: true,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                let content = '';

                content += '<i id="deleteSection1" class="material-icons custom-icons">delete</i>';

                return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

            }
        };
        columnDefs.push(actionsHeader);
        

        let positionHeader = {
            headerName: '',
            field: '',
            rowDrag: true,
            minWidth: 75,
            width: 75,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                //console.log(params);
                return parseInt(params.rowIndex) + 1;
            }
        };
        columnDefs.push(positionHeader);

        let nameHeader = {
            headerName: 'Text',
            field: 'Text',
            minWidth: 400,
            width: 400,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        let checkHeader = {
            headerName: 'Test Question',
            field: 'TestQuestion',
            minWidth: 90,
            width: 90,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                let checked = params.data.IsTestQuestion;
                let rowIndex = params.node.rowIndex;
                if (checked) {
                    //return '<input type="checkbox" id="check" value="" checked>';
                    //return '<div style="padding-left: 0px !important;" class="checkbox"><input id="check' + rowIndex + '" type="checkbox" checked=""><label id="c' + rowIndex + '" for="check' + rowIndex + '"></label></div>';
                    return '<i id="check' + params.data.Id + '" class="material-icons">check</i>';
                } else {
                    //return '<input type="checkbox" id="check" value="">';
                    //return '<div style="padding-left: 0px !important;" class="checkbox"><input id="check'+rowIndex+'" type="checkbox" unchecked><label id="c'+rowIndex+'" for="check'+rowIndex+'"></label></div>';
                    return '<i id="check' + params.data.Id + '" class="material-icons" style="display:none;">check</i>';
                }
            }
        };
        columnDefs.push(checkHeader);

        return columnDefs;
    }

    public onSection1RowClicked(e) { 
        console.log(e);
        let rowIndex = e.rowIndex;
        this.currentRowIndex = rowIndex;
        if (e.event.target !== undefined) {
            let data = e.data;
            let checkboxrowindex = `c${rowIndex}`;

            switch (e.event.target.id) {

                case "deleteSection1":
                    {
                        //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                        this.deleteSection1(rowIndex);
                        break;
                    }
                case checkboxrowindex:
                    {
                        //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                        this.setsection1CheckboxValue(rowIndex, data['IsTestQuestion']);
                        break;
                    }
                default:
                    if (this._onRowDragEnter == undefined) {
                        this.editSelected(data['Id'], data['Text'], 4);
                    }
            }
        }
    }

    setsection1CheckboxValue(index, value: boolean) {
        this.section1_questions[index].IsTestQuestion = !value;
        console.log(this.section1_questions[index]);
    }

    deleteSection1(rowIndex: number) {
        var model = this.section1GridApi.getModel();
        model.rowsToDisplay.splice(rowIndex, 1);
        console.log('question to delete', this.section1_questions[rowIndex]);

        //adding deleted question
        this.section1_questions[rowIndex].Status = 2;

        let currentQuestionId = this.section1_questions[rowIndex].Id;
        let pos = this.deleted_section1_questions.map(function (e) { return e.Id; }).indexOf(currentQuestionId);
        if (pos == -1) {
            this.deleted_section1_questions.push(this.section1_questions[rowIndex]);
        }
        console.log('deleted section1 questions', this.deleted_section1_questions);

        //removing from regularSection questions array
        this.section1_questions.splice(rowIndex, 1);
        let items = this.section1_questions;
        this.section1_questions = [];
        setTimeout(() => {
            this.section1_questions = items;
            console.log('section1_questions', this.section1_questions);
            this.section1GridApi.redrawRows();
        }, 0);

        //this.deleteFromAgGrid(rowIndex, this.section1_questions, this.section1GridApi);
    }

    /*---------------------------------------------*/
    /*------SECTION2 QUESTIONS ag-grid----------*/
    /*---------------------------------------------*/

    onSection2GridReady(params) {
        this.section2GridApi = params.api
        this.sizeToFit(this.section2GridApi);
    }

    createSection2Headers() {
        let columnDefs = new Array();
        //console.log('header');
        //let idHeader = {
        //    headerName: 'Id',
        //    field: 'Id',
        //    minWidth: 200,
        //    width: 200,
        //    hide: true,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(idHeader);

        let actionsHeader = {
            headerName: 'Actions',
            field: '',
            width: 85,
            minWidth: 85,
            suppressSizeToFit: true,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                let content = '';

                content += '<i id="deleteSection2" class="material-icons custom-icons">delete</i>';

                return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

            }
        };
        columnDefs.push(actionsHeader);


        let positionHeader = {
            headerName: '',
            field: '',
            rowDrag: true,
            minWidth: 75,
            width: 75,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                //console.log(params);
                return parseInt(params.rowIndex) + 1;
            }
        };
        columnDefs.push(positionHeader);

        let textHeader = {
            headerName: 'Text',
            field: 'Text',
            minWidth: 400,
            width: 400,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(textHeader);

        let testHeader = {
            headerName: 'Test Question',
            field: 'TestQuestion',
            minWidth: 90,
            width: 90,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                let checked = params.data.IsTestQuestion;
                let rowIndex = params.node.rowIndex;
                if (checked) {
                    //return '<input type="checkbox" id="check" value="" checked>';
                    //return '<div style="padding-left: 0px !important;" class="checkbox"><input id="check' + rowIndex + '" type="checkbox" checked=""><label id="c' + rowIndex + '" for="check' + rowIndex + '"></label></div>';
                    return '<i id="check' + params.data.Id + '" class="material-icons">check</i>';
                } else {
                    //return '<input type="checkbox" id="check" value="">';
                    //return '<div style="padding-left: 0px !important;" class="checkbox"><input id="check'+rowIndex+'" type="checkbox" unchecked><label id="c'+rowIndex+'" for="check'+rowIndex+'"></label></div>';
                    return '<i id="check' + params.data.Id + '" class="material-icons" style="display:none;">check</i>';
                }
            }
        };
        columnDefs.push(testHeader);

        return columnDefs;
    }

    public onSection2RowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            let rowIndex = e.rowIndex;
            this.currentRowIndex = rowIndex;
            let checkboxrowindex = `c${rowIndex}`;

            switch (e.event.target.id) {

                case "deleteSection2":
                    {
                        //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                        this.deleteSection2(rowIndex);
                        break;
                    }
                case checkboxrowindex:
                    {
                        //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                        this.setSection2CheckboxValue(rowIndex, data['IsTestQuestion']);
                        break;
                    }
                default:
                    if (this._onRowDragEnter == undefined) {
                        this.editSelected(data['Id'], data['Text'], 5);
                    }
            }
        }
    }

    setSection2CheckboxValue(index, value: boolean) {
        this.section2_questions[index].IsTestQuestion = !value;
        console.log(this.section2_questions[index]);
    }


    deleteSection2(rowIndex: number) {
        var model = this.section2GridApi.getModel();
        model.rowsToDisplay.splice(rowIndex, 1);
        console.log('question to delete', this.section2_questions[rowIndex]);

        //adding deleted question
        this.section2_questions[rowIndex].Status = 2;

        let currentQuestionId = this.section2_questions[rowIndex].Id;
        let pos = this.deleted_section2_questions.map(function (e) { return e.Id; }).indexOf(currentQuestionId);
        if (pos == -1) {
            this.deleted_section2_questions.push(this.section2_questions[rowIndex]);
        }
        console.log('deleted section2 questions', this.deleted_section2_questions);

        this.section2_questions.splice(rowIndex, 1);
        let items = this.section2_questions;
        this.section2_questions = [];
        setTimeout(() => {
            this.section2_questions = items;
            console.log(this.section2_questions);
            this.section2GridApi.redrawRows();
        }, 0);
    }

    validateDecimal(value) {

        var rx = /^\d+(?:\.\d{1,2})?$/

        if (rx.test(value)) {
            var res = value.split(".");
            if (res.length > 1) {
                if (res[1].length > 2) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
            
        }
        else {
                this.assessmentPrice = value.substring(0, value.length - 1);
                return false;
        }
    }

    setTemplatesSelects(arrayIds: string[]) {
        setTimeout(() => {
            arrayIds.forEach((item) => {
                let currentItemId = $(`#${item}`).val();
                console.log(currentItemId);
                if (isNull(currentItemId) || isUndefined(currentItemId)) {
                    $(`#${item} :nth-child(1)`).prop('selected', true);
                }
            });
        },1000);

    }

}

class PostSaveAssessmentData implements IPostSaveAssessmentData {
    id: number;
    name: string;
    niche: string;
    price: number;
    major: string;
    minor: string;
    sections: any;
    emailTemplates: any[];
    reportTemplates: any[];
    is360: boolean;
}
interface IPostSaveAssessmentData {
    id: number;
    name: string;
    niche: string;
    price: number;
    major: string;
    minor: string;
    sections: any;
    emailTemplates: any[];
    reportTemplates: any[];
    is360: boolean;
}

